import React from "react";

const SK_STYLES = `
.hw-ckskel{padding:24px 0}
.hw-ckskel .bx{background:#e9edf3;border-radius:8px;animation:hwCkPulse 1.4s ease-in-out infinite}
@keyframes hwCkPulse{0%,100%{opacity:1}50%{opacity:.5}}
.hw-ckskel--hero{background:#f3f7ff;border:1px solid #e3eafb;border-radius:14px;padding:22px 24px;display:flex;align-items:center;justify-content:space-between;gap:16px;margin-bottom:24px}
.hw-ckskel--cols{display:flex;gap:24px;flex-wrap:wrap;align-items:flex-start}
.hw-ckskel--main{flex:1 1 520px;min-width:0;display:flex;flex-direction:column;gap:20px}
.hw-ckskel--aside{flex:0 0 360px;max-width:100%}
.hw-ckskel--card{border:1px solid #e6e8ee;border-radius:14px;padding:20px}
.hw-ckskel--row{display:flex;gap:14px;align-items:center}
@media (max-width:991px){.hw-ckskel--aside{flex:1 1 100%}}
`;

const Bx = ({ w, h, r = 8, mb = 0, style }) => (
  <div className="bx" style={{ width: w, height: h, borderRadius: r, marginBottom: mb, ...style }} />
);

export const HotelConfirmSkeleton = () => (
  <div className="hw-page--width">
    <style>{SK_STYLES}</style>
    <div className="hw-ckskel">
      <div className="hw-ckskel--hero">
        <Bx w="150px" h={18} />
        <Bx w="180px" h={18} />
      </div>

      <div className="hw-ckskel--cols">
        <div className="hw-ckskel--main">
          <div className="hw-ckskel--card">
            <div className="hw-ckskel--row" style={{ marginBottom: 16 }}>
              <Bx w="110px" h={90} r={10} />
              <div style={{ flex: 1, minWidth: 0 }}>
                <Bx w="60%" h={18} mb={10} />
                <Bx w="80%" h={13} mb={8} />
                <Bx w="40%" h={13} />
              </div>
            </div>
            <Bx w="100%" h={1} style={{ background: "#eef1f6", margin: "4px 0 16px" }} />
            <div style={{ display: "flex", gap: 20, flexWrap: "wrap" }}>
              {[0, 1, 2].map((i) => (
                <div key={i} style={{ flex: "1 1 120px" }}>
                  <Bx w="70%" h={12} mb={8} />
                  <Bx w="90%" h={16} />
                </div>
              ))}
            </div>
          </div>

          <div className="hw-ckskel--card">
            <Bx w="180px" h={18} mb={18} />
            {[0, 1].map((r) => (
              <div key={r} style={{ display: "flex", gap: 16, flexWrap: "wrap", marginBottom: r === 0 ? 18 : 0 }}>
                {[0, 1, 2].map((c) => (
                  <div key={c} style={{ flex: "1 1 150px" }}>
                    <Bx w="55%" h={12} mb={8} />
                    <Bx w="100%" h={42} r={10} />
                  </div>
                ))}
              </div>
            ))}
          </div>

          <div className="hw-ckskel--card">
            <Bx w="150px" h={18} mb={16} />
            <Bx w="100%" h={13} mb={10} />
            <Bx w="92%" h={13} mb={10} />
            <Bx w="70%" h={13} />
          </div>
        </div>

        <div className="hw-ckskel--aside">
          <div className="hw-ckskel--card" style={{ marginBottom: 20 }}>
            <Bx w="60%" h={16} mb={14} />
            <Bx w="100%" h={90} r={10} />
          </div>
          <div className="hw-ckskel--card">
            <Bx w="50%" h={18} mb={18} />
            {[0, 1, 2, 3].map((i) => (
              <div key={i} style={{ display: "flex", justifyContent: "space-between", marginBottom: 14 }}>
                <Bx w="45%" h={13} />
                <Bx w="22%" h={13} />
              </div>
            ))}
            <Bx w="100%" h={1} style={{ background: "#eef1f6", margin: "6px 0 16px" }} />
            <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 20 }}>
              <Bx w="35%" h={18} />
              <Bx w="28%" h={18} />
            </div>
            <Bx w="100%" h={46} r={10} />
          </div>
        </div>
      </div>
    </div>
  </div>
);

export default HotelConfirmSkeleton;
